import { useEffect, useRef, useState } from "react";

function useCountUp(target, duration = 1800, active) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!active) return undefined;

    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [target, duration, active]);

  return count;
}

function StatItem({ value, suffix, label }) {
  const ref = useRef(null);
  const [active, setActive] = useState(false);
  const count = useCountUp(value, 1800, active);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setActive(true);
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="stat-item">
      <span className="stat-item__value">{count}{suffix}</span>
      <span className="stat-item__label">{label}</span>
    </div>
  );
}

export default function StatsBar({ section, items = [] }) {
  if (!section || section.is_enabled === 0 || items.length === 0) return null;

  return (
    <section className="stats-bar" aria-label="College statistics">
      <div className="stats-bar__inner">
        {items.map((item) => (
          <StatItem
            key={item.id}
            value={Number(item.extra?.value || 0)}
            suffix={item.extra?.suffix || ""}
            label={item.title}
          />
        ))}
      </div>
    </section>
  );
}
